export default __webpack_public_path__ + "static/media/arrow-down-circle.5e1b9426.svg";